import React from "react";
import { faBan, faMap } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const FuelPlanLoading = () => (
  <div className="fuel-plan-page">
    <div className="fuel-plan-loading-shell">
      <div className="fuel-plan-loading-route" aria-hidden="true">
        <span />
        <i />
        <span />
        <i />
        <span />
      </div>
      <h1>Preparing your fuel plan</h1>
      <div className="fuel-plan-loading-steps">
        <span>Checking load details</span>
        <span>Reviewing route</span>
        <span>Building recommendations</span>
      </div>
    </div>
  </div>
);

export const FuelPlanUnavailable = ({
  message,
  feedback,
}: {
  message: string;
  feedback?: React.ReactNode;
}) => (
  <div className="fuel-plan-page fuel-plan-unavailable-page">
    <div className="fuel-plan-unavailable-card">
      <div className="fuel-plan-unavailable-map" aria-hidden="true">
        <FontAwesomeIcon
          className="fuel-plan-unavailable-map-icon"
          icon={faMap}
        />
        <FontAwesomeIcon
          className="fuel-plan-unavailable-no-icon"
          icon={faBan}
        />
      </div>
      <h1>Fuel plan unavailable</h1>
      <p>
        We could not build a fuel plan for this load. Please use your standard
        fuel stop guidance.
      </p>
      <a className="fuel-plan-unavailable-button" href="/load-confirmation">
        Back to My Loads
      </a>
      <div className="fuel-plan-unavailable-note">
        <span aria-hidden="true">i</span>
        <p>
          {message || "You can still use the standard fuel stop reference."}
        </p>
      </div>
      {feedback}
    </div>
  </div>
);
